import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    // 1) URL prefix wins (e.g. /en, /de, /tr) — eliminates FOUC for direct visits
    try {
      const seg = window.location.pathname.split("/").filter(Boolean)[0];
      if (seg && ["de", "en", "tr"].includes(seg)) return seg;
    } catch (e) {}
    // 2) Persisted choice
    try {
      const saved = localStorage.getItem("qrmp_lang");
      if (saved && ["de", "en", "tr"].includes(saved)) return saved;
    } catch (e) {}
    // 3) Default
    return "de";
  });

  useEffect(() => {
    localStorage.setItem("qrmp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const keys = path.split(".");
    let val = translations[lang] || translations.de;
    for (const k of keys) {
      val = val?.[k];
      if (val === undefined) {
        // fallback to english
        let fb = translations.en;
        for (const k2 of keys) fb = fb?.[k2];
        return fb || path;
      }
    }
    return val;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
};
